import { colors } from '@microfrontends/react-components'
import { ArrowIcon, BenefitDescription, CollapseBtnBenefit, CustomCollapse, HeaderCollapseCard } from './Benefit.css'
import { TCompanyBenefit } from '../CompanyDetail/type'
import Icon from './Icon'

interface IProps {
    benefit: TCompanyBenefit
}

export default function CollapseBenefitCard({ benefit }: IProps) {
    return (
        <CustomCollapse
            custom={{
                alwaysShowViewMore: true,
                enable: true,
                viewMoreText: (isCollapse: boolean) =>
                    isCollapse ? (
                        <CollapseBtnBenefit isAbsolute>
                            <ArrowIcon />
                        </CollapseBtnBenefit>
                    ) : (
                        <CollapseBtnBenefit isAbsolute>
                            <ArrowIcon isCollapse />
                        </CollapseBtnBenefit>
                    )
            }}
            collapse={true}
            header={
                <HeaderCollapseCard bgColor={colors.primary[95]}>
                    <Icon benefitId={benefit.benefitId} color={colors.primary[40]} />
                    <span> {benefit.benefitName}</span>
                </HeaderCollapseCard>
            }
        >
            <BenefitDescription
                bgColor={colors.primary[95]}
                style={{
                    borderRadius: '0 0 6px 6px',
                    height: 'auto',
                    padding: '0 12px 16px 12px',
                    marginBottom: '12px'
                }}
                dangerouslySetInnerHTML={{ __html: benefit.benefitDescription }}
            />
        </CustomCollapse>
    )
}
